module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"details":"for media enquiries please contact ","title":"Get in touch"},"it":{"details":"","title":""},"lt":{"details":"Žurnalistams","title":"Susisiekite su mumis"},"pl":{"details":"w sprawie zapytań od mediów prosimy o kontakt ","title":"Kontakt"}}')
  delete Component.options._Ctor
}
